import { useState, useEffect } from 'react';
// ==== تم استبدال استدعاءات Firebase بـ apiClient ====
import apiClient from '../api/axiosConfig';

export const useJobs = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true); // حالة التحميل
  const [error, setError] = useState(null); // حالة الخطأ

  useEffect(() => {
    const fetchJobs = async () => {
      setLoading(true); // ابدأ التحميل
      setError(null); // أعد تعيين أي أخطاء سابقة
      try {
        // ==== هذا هو الجزء الذي تم تغييره بالكامل ====
        // استدعاء الـ API الخاص بـ Laravel لجلب قائمة الوظائف
        const response = await apiClient.get('/jobs');

        // البيانات التي نحتاجها موجودة داخل response.data.data
        setJobs(response.data.data);

      } catch (err) {
        console.error("Error fetching jobs from Laravel API:", err);
        setError("فشل تحميل الوظائف. يرجى المحاولة مرة أخرى.");
      } finally {
        setLoading(false); // أوقف التحميل (سواء نجح الطلب أو فشل)
      }
    };

    fetchJobs();
  }, []); // سيبقى هذا يعمل مرة واحدة عند تحميل المكون

  // إرجاع الحالات الجديدة ليتمكن المكون من استخدامها
  return { jobs, loading, error, jobsCount: jobs.length };
};